<tr class="total two-columns-group-sticky">
  <td class="col-first-level">
    <app-table-group-icon data-qa="bm-hide-mgm-section"
                          [formControl]="budgetForm().controls.modelData.controls.mgmFee.controls.showSection"/>
  </td>
  <td class="col-second-level" colspan="3">
    <div class="flex justify-between items-center">
      <div>Management fees</div>
      @if (isEditState()) {
        <app-button
          data-qa="bm-add-button-mgm"
          [size]="'xxsmall'"
          [type]="'grey-accent'"
          [iconName]="'plus.svg'"
          (buttonClick)="onMgmFeeGroupAction(BmGroupAction.ADD)">Group
        </app-button>
      }
    </div>
  </td>
  <td class="blank-space col-fifth-level"></td>
  @for (total of budgetFormValue$$().modelData.mgmFee.total; track total) {
    <td
      [attr.data-qa]="'bm-mgm-total-' + total.period.quarterNumber + '-' + total.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="total.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(total.period.yearNumber))"
      [hidden]="total.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(total.period.yearNumber)">
      {{ total.itemValue | switcherDashBraces : 1 : 0 }}
    </td>
    @if (total.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(total.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }

  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td data-qa="bm-mgm-total-row"
      class="right-sticky right-[5.5rem] bold600">{{ budgetFormValue$$().modelData.mgmFee.totalRow | switcherDashBraces : 1 : 0 }}
  </td>
  <td data-qa="bm-mgm-total-row-pcnt"
      class="right-sticky right-0 bold600">{{ budgetFormValue$$().modelData.mgmFee.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
  </td>
</tr>

@if (budgetForm().value.modelData.mgmFee.showSection) {
  <!-- Mgm fee   -->
  @for (group of budgetFormValue$$().modelData.mgmFee.groups; track group) {
    @let groupControl = budgetForm().controls.modelData.controls.mgmFee.controls.groups.controls[$index];
    <tr class="three-columns-group-sticky">
      <td class="col-first-level">
        @if (isEditState()) {
          <app-three-dots-menu [matMenuTriggerFor]="isEditState() ? menu : null">
            <mat-menu #menu="matMenu">
              <ul class="list">
                <app-drop-down-item
                  [attr.data-qa]="'bm-mgm-rename-gr' + group.name"
                  class="w-full"
                  [text]="'Rename'"
                  [iconNameAndStyling]="'edit.svg'"
                  (itemClick)="onMgmFeeGroupAction(BmGroupAction.RENAME, groupControl)">
                </app-drop-down-item>
                <app-drop-down-item
                  [attr.data-qa]="'bm-mgm-duplicate-gr' + group.name"
                  class="w-full"
                  [text]="'Duplicate'"
                  [iconNameAndStyling]="'copy.svg'"
                  (itemClick)="onMgmFeeGroupAction(BmGroupAction.DUPLICATE, groupControl)">
                </app-drop-down-item>
                <app-drop-down-item
                  [attr.data-qa]="'bm-mgm-delete-gr' + group.name"
                  class="w-full"
                  [text]="'Delete'"
                  [menuItemClass]="'red'"
                  [iconNameAndStyling]="'delete.svg'"
                  (itemClick)="onMgmFeeGroupAction(BmGroupAction.DELETE, groupControl)">
                </app-drop-down-item>
              </ul>
            </mat-menu>
          </app-three-dots-menu>
        }
      </td>
      <td class="col-second-level">
        <app-table-group-icon
          [attr.data-qa]="'bm-mgm-hide-group-' + group.name"
          [formControl]="groupControl.controls.showGroup">
        </app-table-group-icon>
      </td>
      @if (group.isRenameMode) {
        <td class="col-third-level" colspan="2">
          <app-input
            [attr.data-qa]="'bm-mgm-group-rename-input-' + group.name"
            [formControl]="groupControl.controls.name"
            [suffixFirstIcon]="'close.svg; black-9'"
            [suffixSecondIcon]="groupControl.controls.name.invalid ? '' : 'check.svg; main-8'"
            [additionalClass]="groupControl.controls.name.invalid ? 'error' : ''"
            (suffixFirstIconEmitter)="onMgmFeeGroupAction(BmGroupAction.RENAME_CANCEL, groupControl)"
            (suffixSecondIconEmitter)="onMgmFeeGroupAction(BmGroupAction.RENAME_SAVE, groupControl)">
          </app-input>
        </td>
      } @else {
        <td
          [attr.data-qa]="'bm-mgm-group-name-' + group.name"
          class="bold500 col-third-level"
          colspan="2">
          {{ group.name }}
        </td>
      }
      <td class="blank-space col-fifth-level"></td>
      @for (total of group.total; track total) {
        <td
          [attr.data-qa]="'bm-mgm-group-total-' + total.period.quarterNumber + '-' + total.period.yearNumber"
          [class.bg-black-2]="total.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(total.period.yearNumber))"
          [hidden]="total.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(total.period.yearNumber)"
          class="bold600">
          {{ total.itemValue | switcherDashBraces : 1 : 0 }}
        </td>
        @if (total.period.type === BmPeriodEnum.YEAR && !$last) {
          <td
            [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(total.period.yearNumber)"
            class="blank-space">
          </td>
        }
      }
      <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
      <td class="blank-space right-sticky right-[11rem]"></td>
      <td
        [attr.data-qa]="'bm-mgm-group-total-row-' + group.name"
        class="right-sticky right-[5.5rem] bold600">
        {{ group.totalRow | switcherDashBraces : 1 : 0 }}
      </td>
      <td
        [attr.data-qa]="'bm-mgm-group-total-row-pcnt' + group.name"
        class="right-sticky right-0 bold600">
        {{ group.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
      </td>
    </tr>
    @if (groupControl.value.showGroup) {
      <!-- Commitment -->
      <tr appOnHover #commitment_tr="onHover" class="three-columns-group-sticky">
        <td class="col-first-level"></td>
        <td class="col-second-level"></td>
        @if (isEditState()) {
          <td class="col-third-level" colspan="2">
            <div class="flex items-center justify-between !pl-[0.8rem]">
              <span>Commitment</span>
              <app-input
                [attr.data-qa]="'bm-mgm-commitment-std-val-' + group.name"
                class="w-5.625"
                [formControl]="groupControl.controls.subGroups.controls.commitment.controls.standardValue"
                [isShrinked]="true"
                [thousandSeparator]="','"
                [separator]="'separator.0'">
              </app-input>
            </div>
          </td>
          <td class="blank-space col-fifth-level"></td>
          @for (data of group.subGroups.commitment.items; track data) {
            @let dataControl = groupControl.controls.subGroups.controls.commitment.controls.items.controls[$index];
            <td
              [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
              [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
              <app-input
                [attr.data-qa]="'bm-mgm-commitment-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                [formControl]="dataControl.controls.itemValue"
                [thousandSeparator]="','"
                [separator]="'separator.0'"
                [isShrinked]="true"
                [suffixFirstIcon]="data.period.type === BmPeriodEnum.YEAR ? '' : (dataControl.controls.itemValue.disabled ? (commitment_tr.hovered() ? 'edit.svg' : '') : 'close.svg')"
                (suffixFirstIconEmitter)="editItemValue(dataControl)">
              </app-input>
            </td>
            @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
              <td
                [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
                class="blank-space">
              </td>
            }
          }
        } @else {
          <td class="col-third-level !pl-[0.8rem]" colspan="2">Commitment</td>
          <td class="blank-space col-fifth-level"></td>
          @for (data of group.subGroups.commitment.items; track data) {
            <td
              [attr.data-qa]="'bm-mgm-commitment-val' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
              [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)"
              [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))">
              {{ data.itemValue | switcherDashBraces : 1 : 0 }}
            </td>
            @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
              <td
                [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
                class="blank-space">
              </td>
            }
          }
        }
        <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[11rem]"></td>
        <td class="right-sticky right-[5.5rem]"></td>
        <td class="right-sticky right-0"></td>
      </tr>

      <!-- Management fees, % -->
      <tr appOnHover #mgm_fee_pcnt_tr="onHover" class="three-columns-group-sticky">
        <td class="col-first-level"></td>
        <td class="col-second-level"></td>
        @if (isEditState()) {
          <td class="col-third-level" colspan="2">
            <div class="flex items-center justify-between !pl-[0.8rem]">
              <span>Management fees, %</span>
              <app-input
                [attr.data-qa]="'bm-mgm-mgm-pcnt-std-val-' + group.name"
                class="w-[4rem]"
                [formControl]="groupControl.controls.subGroups.controls.mgmFeesPcnt.controls.standardValue"
                [isShrinked]="true"
                [thousandSeparator]="','"
                [suffix]="'%'"
                [additionalClass]="groupControl.controls.subGroups.controls.mgmFeesPcnt.controls.standardValue.invalid ? 'error' : ''"
                [separator]="'separator.2'">
              </app-input>
            </div>
          </td>
          <td class="blank-space col-fifth-level"></td>
          @for (data of group.subGroups.mgmFeesPcnt.items; track data) {
            @let dataControl = groupControl.controls.subGroups.controls.mgmFeesPcnt.controls.items.controls[$index];
            <td
              [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
              [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
              <app-input
                [attr.data-qa]="'bm-mgm-mgm-pcnt' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                [formControl]="dataControl.controls.itemValue"
                [isShrinked]="true"
                [thousandSeparator]="','"
                [suffix]="'%'"
                [separator]="'separator.2'"
                [suffixFirstIcon]="dataControl.controls.itemValue.disabled ? (mgm_fee_pcnt_tr.hovered() ? 'edit.svg' : '') : 'close.svg'"
                (suffixFirstIconEmitter)="editItemValue(dataControl, BmGroupType.MGM_FEE_PCNT)">
              </app-input>
            </td>
            @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
              <td
                [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
                class="blank-space">
              </td>
            }
          }
        } @else {
          <td class="col-third-level !pl-[0.8rem]" colspan="2">Management fees, %</td>
          <td class="blank-space col-fifth-level"></td>
          @for (data of group.subGroups.mgmFeesPcnt.items; track data) {
            <td
              [attr.data-qa]="'bm-mgm-mgm-pcnt-val' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
              [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
              [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
              {{ data.itemValue | switcherDashBraces : 1 : 2: false : '' : '%' }}
            </td>
            @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
              <td
                [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
                class="blank-space">
              </td>
            }
          }
        }
        <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[11rem]"></td>
        <td class="right-sticky right-[5.5rem]"></td>
        <td class="right-sticky right-0"></td>
      </tr>
      <!-- % discount -->
      @if ((isEditState() || group.subGroups.pcntOfMgmFees.isSelected)) {
        <tr
          appOnHover #pcnt_of_mgm_fee_tr="onHover" class="three-columns-group-sticky">
          <td class="col-first-level"></td>
          <td class="col-second-level"></td>
          <!--  % discount - ROW NAME -->
          @if (isEditState()) {
            <td class="col-third-level" colspan="2">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-0.15625 !pl-[0.3rem]">
                  <app-checkbox
                    [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-selected-' + group.name"
                    [formControl]="groupControl.controls.subGroups.controls.pcntOfMgmFees.controls.isSelected">
                  </app-checkbox>
                  <span>% Discount</span>
                </div>
                @if (group.subGroups.pcntOfMgmFees.isSelected) {
                  <app-input
                    [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-std-val-' + group.name"
                    class="w-[4rem]"
                    [formControl]="groupControl.controls.subGroups.controls.pcntOfMgmFees.controls.standardValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [suffix]="'%'"
                    [additionalClass]="groupControl.controls.subGroups.controls.pcntOfMgmFees.controls.standardValue.invalid ? 'error' : ''"
                    [separator]="'separator.2'">
                  </app-input>
                }
              </div>
            </td>
          } @else {
            <td class="col-third-level !pl-[0.8rem]" colspan="2">% Discount</td>
          }
          <td class="blank-space col-fifth-level"></td>

          <!--  % Discount - ROW VALUES -->
          @for (data of group.subGroups.pcntOfMgmFees.items; track data) {
            @let dataControl = groupControl.controls.subGroups.controls.pcntOfMgmFees.controls.items.controls[$index];
            <!--  % Discount - ROW VALUES - EDIT STATE + SELECTED-->
            @if (isEditState() && group.subGroups.pcntOfMgmFees.isSelected) {
              <td
                [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
                [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
                <app-input
                  [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                  [formControl]="dataControl.controls.itemValue"
                  [isShrinked]="true"
                  [thousandSeparator]="','"
                  [suffix]="'%'"
                  [separator]="'separator.1'"
                  [suffixFirstIcon]="data.period.type === BmPeriodEnum.YEAR ? '' : (dataControl.controls.itemValue.disabled ? (pcnt_of_mgm_fee_tr.hovered() ? 'edit.svg' : '') : 'close.svg')"
                  (suffixFirstIconEmitter)="editItemValue(dataControl)">
                </app-input>
              </td>
            }
            <!--  % Discount - ROW VALUES - EDIT STATE + NOT SELECTED-->
            @if (isEditState() && !group.subGroups.pcntOfMgmFees.isSelected) {
              <td
                [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-val-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
                [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
              </td>
            }
            <!--  % Discount - ROW VALUES - NOT EDIT STATE + SELECTED-->
            @if (!isEditState() && group.subGroups.pcntOfMgmFees.isSelected) {
              <td
                [attr.data-qa]="'bm-mgm-pcnt-of-mgm-fee-val-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
                [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
                {{ data.itemValue | switcherDashBraces : 1 : 1: false : '' : '%' }}
              </td>
            }
            @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
              <td
                [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
                class="blank-space">
              </td>
            }
          }
          <!--  % Discount - ROW TOTAL VALUES -->
          <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
          <td class="blank-space right-sticky right-[11rem]"></td>
          <td class="right-sticky right-[5.5rem]"></td>
          <td class="right-sticky right-0"></td>
        </tr>
      }
      <!-- Management fees -->
      <tr class="three-columns-group-sticky">
        <td class="col-first-level"></td>
        <td class="col-second-level"></td>
        <td class="col-third-level !pl-[0.8rem]" colspan="2">Management fees</td>
        <td class="blank-space col-fifth-level"></td>
        @for (data of group.subGroups.mgmFeeValues.items; track data) {
          <td
            [attr.data-qa]="'bm-mgm-mgm-fee-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
            [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
            [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
            {{ data.itemValue | switcherDashBraces : 1 : 0 }}
          </td>
          @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
            <td
              [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
              class="blank-space">
            </td>
          }
        }
        <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
        <td class="blank-space right-sticky right-[11rem]"></td>
        <td
          class="right-sticky right-[5.5rem]">{{ group.subGroups.mgmFeeValues.totalRow | switcherDashBraces : 1 : 0 }}
        </td>
        <td
          class="right-sticky right-0">{{ group.subGroups.mgmFeeValues.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
        </td>
      </tr>
      <!-- Catch-up -->
      @if ((isEditState() || group.subGroups.catchUp.isSelected) && group.subGroups.commitment.isCatchUpAvailable) {
        <tr
          class="three-columns-group-sticky">
          <td class="col-first-level"></td>
          <td class="col-second-level"></td>
          <!--  Catch-up - ROW NAME -->
          @if (isEditState()) {
            <td class="col-third-level" colspan="2">
              <div class="flex items-center gap-0.15625 !pl-[0.3rem]">
                <app-checkbox
                  [attr.data-qa]="'bm-mgm-catch-up-selected-' + group.name"
                  [formControl]="groupControl.controls.subGroups.controls.catchUp.controls.isSelected">
                </app-checkbox>
                <span>Catch-up</span>
              </div>
            </td>
          } @else {
            <td class="col-third-level !pl-[0.8rem]" colspan="2">Catch-up</td>
          }
          <td class="blank-space col-fifth-level"></td>
          <!--  Catch-up - ROW VALUES -->

          @for (data of group.subGroups.catchUp.items; track data) {
            @if (group.subGroups.catchUp.isSelected) {
              <td
                [attr.data-qa]="'bm-mgm-catch-up-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
                [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
                {{ data.itemValue | switcherDashBraces : 1 : 0 }}
              </td>
            } @else {
              <td
                [attr.data-qa]="'bm-mgm-catch-up-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
                [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
              </td>
            }
            @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
              <td
                [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
                class="blank-space">
              </td>
            }
          }
          <!--  Catch-up - ROW TOTAL VALUES -->
          <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
          <td class="blank-space right-sticky right-[11rem]"></td>
          <td [attr.data-qa]="'bm-mgm-catch-up-row-' + group.name"
              class="right-sticky right-[5.5rem]">
            @if (group.subGroups.catchUp.isSelected) {
              <span>
                {{ group.subGroups.catchUp.totalRow | switcherDashBraces : 1 : 0 }}
              </span>
            }
          </td>
          <td [attr.data-qa]="'bm-mgm-catch-up-row-pcnt-' + group.name"
              class="right-sticky right-0">
            @if (group.subGroups.catchUp.isSelected) {
              <span>
                {{ group.subGroups.catchUp.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
              </span>
            }
          </td>
        </tr>
      }
      <!-- VAT, % -->
      @if (isEditState() || group.subGroups.vatPcnt.isSelected) {
        <tr appOnHover #vat_tr="onHover" class="three-columns-group-sticky">
          <td class="col-first-level"></td>
          <td class="col-second-level"></td>
          <!--  VAT, % - ROW NAME -->
          @if (isEditState()) {
            <td class="col-third-level" colspan="2">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-0.15625 !pl-[0.3rem]">
                  <app-checkbox
                    [attr.data-qa]="'bm-mgm-vat-selected-' + group.name"
                    [formControl]="groupControl.controls.subGroups.controls.vatPcnt.controls.isSelected">
                  </app-checkbox>
                  <span>VAT, %</span>
                </div>
                @if (group.subGroups.vatPcnt.isSelected) {
                  <app-input
                    [attr.data-qa]="'bm-mgm-vat-pcnt-std-val-' + group.name"
                    class="w-[4rem]"
                    [formControl]="groupControl.controls.subGroups.controls.vatPcnt.controls.standardValue"
                    [isShrinked]="true"
                    [thousandSeparator]="','"
                    [suffix]="'%'"
                    [additionalClass]="groupControl.controls.subGroups.controls.vatPcnt.controls.standardValue.invalid ? 'error' : ''"
                    [separator]="'separator.2'">
                  </app-input>
                }
              </div>
            </td>
          } @else {
            <td class="col-third-level !pl-[0.8rem]" colspan="2">VAT, %</td>
          }
          <td class="blank-space col-fifth-level"></td>
          <!--  VAT, % - ROW VALUES -->

          @for (data of group.subGroups.vatPcnt.items; track data) {
            @let dataControl = groupControl.controls.subGroups.controls.vatPcnt.controls.items.controls[$index];
            <!--  VAT, % - ROW VALUES - EDIT STATE + VAT SELECTED-->
            @if (isEditState() && group.subGroups.vatPcnt.isSelected) {
              <td
                [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
                [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
                <app-input
                  [attr.data-qa]="'bm-mgm-vat-pcnt-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                  [formControl]="dataControl.controls.itemValue"
                  [isShrinked]="true"
                  [thousandSeparator]="','"
                  [suffix]="'%'"
                  [separator]="'separator.2'"
                  [suffixFirstIcon]="data.period.type === BmPeriodEnum.YEAR ? '' : (dataControl.controls.itemValue.disabled ? (vat_tr.hovered() ? 'edit.svg' : '') : 'close.svg')"
                  (suffixFirstIconEmitter)="editItemValue(dataControl)">
                </app-input>
              </td>
            }
            <!--  VAT, % - ROW VALUES - EDIT STATE + VAT NOT SELECTED-->
            @if (isEditState() && !group.subGroups.vatPcnt.isSelected) {
              <td
                [attr.data-qa]="'bm-mgm-vat-pcnt-val-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
                [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
              </td>
            }
            <!--  VAT, % - ROW VALUES - NOT EDIT STATE + VAT SELECTED-->
            @if (!isEditState() && group.subGroups.vatPcnt.isSelected) {
              <td
                [attr.data-qa]="'bm-mgm-vat-pcnt-val-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
                [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
                [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
                {{ data.itemValue | switcherDashBraces : 1 : 2: false : '' : '%' }}
              </td>
            }
            @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
              <td
                [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
                class="blank-space">
              </td>
            }
          }
          <!--  VAT, % - ROW TOTAL VALUE -->
          <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
          <td class="blank-space right-sticky right-[11rem]"></td>
          <td class="right-sticky right-[5.5rem]"></td>
          <td class="right-sticky right-0"></td>
        </tr>
      }
      <!-- VAT -->
      @if (group.subGroups.vatPcnt.isSelected) {
        <tr class="three-columns-group-sticky">
          <td class="col-first-level"></td>
          <td class="col-second-level"></td>
          <td class="col-third-level !pl-[0.8rem]" colspan="2">VAT</td>
          <td class="blank-space col-fifth-level"></td>

          @for (data of group.subGroups.vatValues.items; track data) {
            <td
              [attr.data-qa]="'bm-mgm-vat-val-' + group.name + '-' + data.period.quarterNumber + '-' + data.period.yearNumber"
              [class.bg-black-2]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
              [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
              {{ data.itemValue | switcherDashBraces : 1 : 0 }}
            </td>
            @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
              <td
                [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
                class="blank-space">
              </td>
            }
          }
          <td [class.bg-black-2]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
          <td class="blank-space right-sticky right-[11rem]"></td>
          <td
            [attr.data-qa]="'bm-mgm-vat-row-' + group.name"
            class="right-sticky right-[5.5rem]">
            {{ group.subGroups.vatValues.totalRow | switcherDashBraces : 1 : 0 }}
          </td>
          <td
            [attr.data-qa]="'bm-mgm-vat-row-pcnt-' + group.name"
            class="right-sticky right-0">
            {{ group.subGroups.vatValues.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
          </td>
        </tr>
      }
    }
  }
}
